<template>
  <footer class="footer footer--7">
    <div class="row">
      <div class="col-lg-6 left-part">
        <div class="footer__top">
          <logo></logo>
          <h2>Cheeks&Lips</h2>
        </div>

        <footer-nav></footer-nav>
        <copyright></copyright>
      </div>
      <div class="col-lg-6 right-part">
        <contacts></contacts>
        <paysistems></paysistems>
      </div>
    </div>
  </footer>
</template>

<script>
import Logo from './parts/Logo.vue';
import Slogan from './parts/Slogan.vue';
import FooterNav from './parts/FooterNav.vue';
import Contacts from './parts/Contacts.vue';
import Paysistems from './parts/Paysistems.vue';
import Copyright from './parts/Copyright.vue';

export default {
  components: {
    Logo,
    Slogan,
    FooterNav,
    Contacts,
    Paysistems,
    Copyright,
  },
};
</script>

<style lang="scss" scoped>
.footer--7 {
  &.footer {
    background-color: $black;
    color: $white;
    .left-part {
      background-color: $red;
      padding: 60px 0 60px 300px;
    }
    .right-part {
      padding: 60px 300px 60px 124px;
    }
    .footer__top {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      h2 {
        margin-left: 24px;
        @include font(40, 700);
      }
    }
    .footer__logo {
      img {
        width: 40px;
        height: auto;
      }
    }

    .footer__menu {
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
      li {
        a {
          font-family: $main-font;
          @include font(16, 400);
        }
      }
    }
    .footer__contacts {
      display: flex;
      flex-direction: column;
      height: calc(100% - 80px);
      margin-bottom: 40px;
      &-item {
        @include font(16, 400);
        @media (max-width: $breakpoint-md) {
          &:nth-child(2) {
            margin-top: 20px !important;
          }
          &:nth-child(3) {
            margin-top: 8px;
          }
        }
      }
    }
    .footer__paysistems {
      display: flex;
      gap: 16px;
    }
    @media (max-width: $breakpoint-xl) and (min-width: $breakpoint-lg) {
      .left-part {
        padding: 60px 20px 60px 200px;
      }

      .right-part {
        padding: 60px 200px 60px 20px;
      }
    }
    @media (max-width: $breakpoint-lg) {
      .left-part,
      .right-part {
        padding: 20px 40px;
      }
      .row {
        margin-right: 0;
      }
    }
  }
}
</style>
